import { getJson, patchJson, postJson } from './client';

export async function getSessionUser() {
  return getJson('/api/auth/me');
}

export async function login(email, password) {
  return postJson('/api/auth/login', { email, password });
}

export async function register(email, password, fullName, organization) {
  return postJson('/api/auth/register', { email, password, full_name: fullName, organization });
}

export async function logout() {
  return postJson('/api/auth/logout', {});
}

export async function getAdminUsers() {
  return getJson('/api/auth/admin/users');
}

export async function updateAdminUser(userId, payload) {
  return patchJson(`/api/auth/admin/users/${userId}`, payload);
}

export async function revokeAdminUserSessions(userId) {
  return postJson(`/api/auth/admin/users/${userId}/revoke-sessions`, {});
}
